import { html } from 'lit';
import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import formGroupLabelIndicatorStyles from './form-group-label-indicator.css.js';

class CrntFormGroupLabelIndicator extends CrntElement {
  static {
    this.styles = trustedCSS(formGroupLabelIndicatorStyles);
  }
  static {
    this.tagName = "crnt-form-group-label-indicator";
  }
  render() {
    return html`<slot class="crnt-form-group-label-indicator" part="indicator"></slot>`;
  }
}

export { CrntFormGroupLabelIndicator };
